const WORDS = [
  "ENTERPRISE TRANSFORMATION",
  "AI ENABLEMENT",
  "DATA CENTER MODERNIZATION",
  "CONSTRUCTION PROGRAM MANAGEMENT",
  "CRITICAL INFRASTRUCTURE",
  "DIGITAL INNOVATION",
];

export default function Marquee() {
  const line = [...WORDS, ...WORDS];
  return (
    <section className="relative overflow-hidden border-y border-white/5 bg-nexis-bg/40 py-8" data-testid="marquee">
      <div className="marquee-track">
        {line.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-2xl font-light tracking-tight text-white/30 md:text-4xl">
            {w}
            <span className="h-1.5 w-1.5 rounded-full bg-nexis-blue" />
          </span>
        ))}
      </div>
    </section>
  );
}
